export default function EventsHeroSection() {
  return (
      <section className="py-6 md:py-16 bg-[#FCF8F8]">
          <div className="max-w-7xl mx-auto px-6">
              <div className="grid lg:grid-cols-2 gap-0 md:gap-12 items-center event-box2">
                  {/* Left Content */}
                  <div className="space-y-8">
                      <h1 className="text-4xl font-bold text-[#00889D]">
                          Our Events
                      </h1>

                      <div>
                          <p className="text-lg text-gray-700 leading-relaxed mb-6">
                              We host <span className="text-[#00889D] font-semibold">private
                              events</span> for both adults and kids perfect for birthdays, team gatherings, or mindful
                              celebrations.
                          </p>
                          <p className="text-lg text-gray-700 leading-relaxed mb-6">
                              Explore best fitting options and book your event. Our team will contact you to confirm your reservation and help customize your experience.
                          </p>
                      </div>
                  </div>

                  {/* Right Images */}
                  <div className="space-y-6">
                      <div className="rounded-lg overflow-hidden shadow-lg">
                          <img
                              src="/img/events1.png"
                              alt="Kids enjoying yoga party"
                              className="w-full h-64 object-cover object-top"
                          />
                      </div>
                  </div>
              </div>
          </div>
      </section>
  );
}